import type { WaysTokens } from '../../services/waysApi';

/** A token count from either shape Ways uses: a number, or {total|input+output}. */
export function tokensOf(t: number | WaysTokens | null | undefined): number {
  if (t == null) return 0;
  if (typeof t === 'number') return t;
  return t.total ?? ((t.input ?? 0) + (t.output ?? 0));
}

export function fmtTokens(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return String(n);
}
